(() => {
  const isCart = window.location.pathname === '/cart';
  if(isCart) {
    document.addEventListener("DOMContentLoaded", e => {
      const subtotalElement = document.querySelector(".m-cart__subtotal");
      const vatNumber = subtotalElement.getAttribute("data-vat") || '';
      const taxWrapper = document.querySelector(".bss-b2b-tax-ex-wrapper");
      const inputVat =  document.querySelector(".bss-b2b-vat-input");
      if(inputVat && vatNumber.length) {
        inputVat.value = vatNumber;
      }
      if (subtotalElement && taxWrapper) {
        subtotalElement.parentNode.insertBefore(taxWrapper, subtotalElement);
      }
    })
  }
})();